import React from 'react';
import { GuidelineGroup } from '../GuidelineGroup';

interface Props<X, Y> {
  width: number;
  height: number;
  xTicks: X[];
  yTicks: Y[];
  xScale: (xValue: X) => number;
  yScale: (yValue: Y) => number;
}

export const GridLines = <X, Y>({ width, height, xTicks, yTicks, xScale, yScale }: Props<X, Y>) => (
  <GuidelineGroup data-component="GridLines">
    {xTicks && xTicks.map(t => xScale(t)).map(x => <line key={x} x1={x} x2={x} y2={height} />)}
    {yTicks && yTicks.map(t => yScale(t)).map(y => <line key={y} y1={y} x2={width} y2={y} />)}
  </GuidelineGroup>
);
